module.exports = __webpack_public_path__ + "e8e8b30f1170929b29672e936f5f54c5.jpg";